import { Box, Icon, Text, Tooltip, useToggle } from '@factorialco/deprecated-design-system'
import { WorkingConditionItemFragment } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

interface WorkingConditionValueProps {
  workingConditionName: string
  workingConditionItem: WorkingConditionItemFragment
  value?: string
  fields?: string[]
}

const WorkingConditionValue = ({
  workingConditionName,
  workingConditionItem,
  value,
  fields,
}: WorkingConditionValueProps) => {
  const [open, toggle] = useToggle(false)
  const isLinkedCondition = fields?.includes(workingConditionItem.name)
  const labelOption = { working_condition: workingConditionName }
  const syncedLabel = i18n.t('contract_versions.working_conditions.synced', labelOption)
  const unsyncedLabel = i18n.t('contract_versions.working_conditions.unsynced', labelOption)

  return (
    <Tooltip.Alt
      attachment="bottom center"
      open={open}
      toggle={toggle}
      label={isLinkedCondition ? syncedLabel : unsyncedLabel}
    >
      <Box
        flexDirection="row"
        gap="s4"
        background={
          isLinkedCondition ? 'complementaryBackgroundSubtlest' : 'containerBackgroundSolid'
        }
        borderRadius={{ all: 'abs008' }}
        paddingX="s8"
        paddingY="s4"
        width="fit-content"
      >
        {workingConditionItem && (
          <Icon.Medium
            icon={isLinkedCondition ? 'link' : 'link-remove'}
            color={isLinkedCondition ? 'feedbackIconInfo' : 'iconWarning'}
          />
        )}
        <Text size="300" weight="medium" color="grey1000">
          {value}
        </Text>
      </Box>
    </Tooltip.Alt>
  )
}

export default WorkingConditionValue
